import Types from "./classes/types";

const AppConfig = {
    defines: {
        LANG_URL: process.env.PUBLIC_URL + '/lang/',
        DEFAULT_LANGUAGE: Types.LANGUAGE_RU,
        PROXY_URL: "",
        CONFIG_URL: process.env.PUBLIC_URL + '/config/',
        CONFIG_FILE: 'config.json',
        SUPPORT_EMAIL: '',
        SITE_NAME: 'Proxy',
    },

    languages: [
        Types.LANGUAGE_EN,
        Types.LANGUAGE_RU,
    ],

    site: {
        isChangeTheme: true,
        defaultTheme: Types.THEMES.dark,
        themeColors: {
            [Types.THEMES.dark]: [Types.THEME_COLORS.dark],
            [Types.THEMES.light]: [Types.THEME_COLORS.light],
        },
        logoSrc: './logo.svg'
    },
};

export default AppConfig;
